(function () {
	var SECTION_ID = "cart-drawer";
	var ADDON_STATE_KEY = "mhCdAddonState";
	var CART_LINK_SELECTOR = 'a[href="/cart"], a[href$="/cart"], .head_cart, .site-header__cart, .mh-cd-header-trigger, .minicart__label, .nh-nav-cart-btn';
	var CLOSE_MS = 340;
	var PROGRESS_MS = 600;

	function qs(root, selector) {
		return (root || document).querySelector(selector);
	}

	function qsa(root, selector) {
		return Array.prototype.slice.call((root || document).querySelectorAll(selector));
	}

	function liveDrawer() {
		return document.querySelector("mh-cart-drawer");
	}

	function isCartPageUrl(url) {
		if (!url) return false;
		try {
			var parsed = new URL(String(url), window.location.origin);
			if (parsed.origin !== window.location.origin) return false;
			var path = parsed.pathname.replace(/\/+$/, "") || "/";
			return path === "/cart";
		} catch (e) {
			var pathOnly = String(url).split("?")[0].split("#")[0].replace(/\/+$/, "");
			return pathOnly === "/cart" || pathOnly.slice(-5) === "/cart";
		}
	}

	function isScrollableDrawerTarget(target) {
		return !!(target && target.closest && target.closest(".mh-cd__body"));
	}

	// The upsell strip scrolls sideways. A vertical wheel over it must move the drawer,
	// not get swallowed by that strip. Horizontal trackpad gestures and touch swipes stay
	// on the strip; the scrollbar still drags it on desktop.
	function bindUpsellWheelPassthrough() {
		if (window.__mhCdUpsellWheel) return;
		window.__mhCdUpsellWheel = true;
		document.addEventListener(
			"wheel",
			function (event) {
				var track = event.target && event.target.closest && event.target.closest(".mh-cd__upsell-track");
				if (!track) return;
				if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
				var body = track.closest(".mh-cd__body");
				if (!body) return;
				event.preventDefault();
				body.scrollTop += event.deltaY;
			},
			{ passive: false, capture: true },
		);
	}


	function onLockTouchMove(event) {
		if (isScrollableDrawerTarget(event.target)) return;
		event.preventDefault();
	}

	function onLockWheel(event) {
		if (isScrollableDrawerTarget(event.target)) return;
		event.preventDefault();
	}

	function lockPageScroll() {
		if (document.documentElement.classList.contains("mh-cd-scroll-lock")) return;
		var scrollY = window.scrollY || window.pageYOffset || 0;
		document.documentElement.classList.add("mh-cd-scroll-lock");
		document.body.classList.add("mh-cd-open");
		document.body.style.top = "-" + scrollY + "px";
		document.body.setAttribute("data-mh-cd-scroll-y", String(scrollY));
		document.addEventListener("touchmove", onLockTouchMove, { passive: false });
		document.addEventListener("wheel", onLockWheel, { passive: false });
	}

	function unlockPageScroll() {
		if (!document.documentElement.classList.contains("mh-cd-scroll-lock")) return;
		var scrollY = parseInt(document.body.getAttribute("data-mh-cd-scroll-y") || "0", 10);
		document.documentElement.classList.remove("mh-cd-scroll-lock");
		document.body.classList.remove("mh-cd-open");
		document.body.style.top = "";
		document.body.removeAttribute("data-mh-cd-scroll-y");
		document.removeEventListener("touchmove", onLockTouchMove);
		document.removeEventListener("wheel", onLockWheel);
		window.scrollTo(0, scrollY);
	}

	function readProgressPct(root) {
		var fill = qs(root, "[data-mh-cd-progress-fill], .mh-cd__progress-fill");
		if (!fill) return 0;
		var attr = fill.getAttribute("data-progress-pct");
		if (attr !== null && attr !== "") {
			var fromAttr = parseFloat(attr);
			if (!isNaN(fromAttr)) return Math.max(0, Math.min(100, fromAttr));
		}
		var styleW = fill.style.width;
		if (styleW && styleW.indexOf("%") !== -1) {
			return Math.max(0, Math.min(100, parseFloat(styleW) || 0));
		}
		var track = fill.parentElement;
		if (track && track.clientWidth) {
			return Math.max(0, Math.min(100, (fill.clientWidth / track.clientWidth) * 100));
		}
		return 0;
	}

	function animateProgressNumber(el, fromPct, toPct) {
		if (!el) return;
		var from = Math.round(fromPct);
		var to = Math.round(toPct);
		if (from === to) {
			el.textContent = to + "%";
			return;
		}
		var start = performance.now();
		function frame(now) {
			var t = Math.min(1, (now - start) / PROGRESS_MS);
			var eased = 1 - Math.pow(1 - t, 3);
			el.textContent = Math.round(from + (to - from) * eased) + "%";
			if (t < 1) requestAnimationFrame(frame);
		}
		requestAnimationFrame(frame);
	}

	function animateProgress(root, fromPct) {
		var fill = qs(root, "[data-mh-cd-progress-fill], .mh-cd__progress-fill");
		if (!fill) return;
		var toPct = readProgressPct(root);
		if (fromPct == null || isNaN(fromPct)) fromPct = 0;
		fromPct = Math.max(0, Math.min(100, fromPct));
		fill.style.transition = "none";
		fill.style.width = fromPct + "%";
		void fill.offsetWidth;
		requestAnimationFrame(function () {
			fill.style.transition = "";
			fill.style.width = toPct + "%";
		});
		animateProgressNumber(qs(root, ".mh-cd__progress-pct"), fromPct, toPct);
	}

	class MHCartDrawer extends HTMLElement {
		constructor() {
			super();
			this._internal = false;
			this._closing = false;
			this._wantOpen = false;
			this._refreshing = null;
			this._onKeyUp = this._onKeyUp.bind(this);
		}

		connectedCallback() {
			this.overlay = qs(this, "#MHCartDrawer-Overlay");
			this.panel = qs(this, "#MHCartDrawer");
			this._bindPanelEvents();
			bindGlobalCartTriggers();
			bindAjaxIntercepts();
			bindCartPageRedirectGuard();
			wrapWhereToGo();
			initTrustpilot(this);
			refreshShippingEstimate();
		}

		_bindPanelEvents() {
			var self = this;
			qsa(this, "[data-mh-cd-close]").forEach(function (btn) {
				btn.addEventListener("click", function () {
					self.close();
				});
			});
			if (this.overlay) {
				this.overlay.addEventListener("click", function () {
					self.close();
				});
			}

			qsa(this, "[data-mh-cd-qty-change]").forEach(function (btn) {
				btn.addEventListener("click", function () {
					var wrap = btn.closest("[data-mh-cd-qty]");
					var input = wrap ? qs(wrap, ".mh-cd__qty-input") : null;
					if (!input) return;
					var next = parseInt(input.value, 10) + parseInt(btn.getAttribute("data-mh-cd-qty-change"), 10);
					if (isNaN(next) || next < 0) next = 0;
					input.value = next;
					self.updateQuantity(input.getAttribute("data-index"), next);
				});
			});

			qsa(this, ".mh-cd__qty-input").forEach(function (input) {
				input.addEventListener("change", function () {
					var qty = parseInt(input.value, 10);
					if (isNaN(qty) || qty < 0) qty = 0;
					self.updateQuantity(input.getAttribute("data-index"), qty);
				});
			});

			qsa(this, "[data-mh-cd-remove]").forEach(function (btn) {
				btn.addEventListener("click", function () {
					self.updateQuantity(btn.getAttribute("data-index"), 0);
				});
			});

			qsa(this, "[data-mh-cd-variant-select]").forEach(function (select) {
				select.addEventListener("change", function () {
					var option = select.options[select.selectedIndex];
					var card = select.closest(".mh-cd__upsell-card");
					if (!card) return;
					var addBtn = qs(card, "[data-mh-cd-upsell-add]");
					var priceEl = qs(card, "[data-mh-cd-upsell-price]");
					if (addBtn) {
						addBtn.setAttribute("data-variant-id", select.value);
						addBtn.disabled = option.getAttribute("data-available") === "false";
					}
					if (priceEl && option) {
						var compare = option.getAttribute("data-compare");
						var price = option.getAttribute("data-price");
						var hasCompare = compare && compare !== "" && compare !== price;
						priceEl.innerHTML = hasCompare ? "<s>" + compare + "</s><span>" + price + "</span>" : "<span>" + price + "</span>";
					}
				});
			});

			qsa(this, "[data-mh-cd-upsell-add]").forEach(function (btn) {
				btn.addEventListener("click", function () {
					var card = btn.closest(".mh-cd__upsell-card");
					var select = card ? qs(card, "[data-mh-cd-variant-select]") : null;
					var hidden = card ? qs(card, 'input[name="id"]') : null;
					var variantId = (select && select.value) || (hidden && hidden.value) || btn.getAttribute("data-variant-id");
					if (variantId) self.addItem(variantId, 1, btn);
				});
			});

			qsa(this, "[data-mh-cd-addon-toggle]").forEach(function (btn) {
				btn.addEventListener("click", function () {
					self.toggleAddon(btn.closest("[data-mh-cd-addon]"));
				});
			});
		}

		_onKeyUp(event) {
			if (event.key === "Escape" || event.code === "Escape") this.close();
		}

		open() {
			var self = this;
			this._wantOpen = true;
			this._closing = false;
			this.classList.remove("is-closing");
			lockPageScroll();
			document.addEventListener("keyup", this._onKeyUp);
			if (this.classList.contains("is-open")) return;

			this.classList.add("is-animating");
			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					if (!self.isConnected || !self._wantOpen || self._closing) return;
					self.classList.add("is-open");
					var closeBtn = qs(self, "[data-mh-cd-close]");
					if (closeBtn) closeBtn.focus();
					var panel = self.panel || qs(self, ".mh-cd__panel");
					var clearAnim = function () {
						self.classList.remove("is-animating");
					};
					if (panel) {
						panel.addEventListener("transitionend", function onEnd(event) {
							if (event.target !== panel) return;
							if (event.propertyName && event.propertyName !== "transform") return;
							panel.removeEventListener("transitionend", onEnd);
							clearAnim();
						});
					}
					setTimeout(clearAnim, 400);
				});
			});
		}

		_keepOpenWithoutAnimation() {
			this._wantOpen = true;
			this._closing = false;
			this.classList.remove("is-closing");
			this.classList.add("is-open");
			lockPageScroll();
			document.addEventListener("keyup", this._onKeyUp);
		}

		close() {
			var self = this;
			if ((!this.classList.contains("is-open") && !this._wantOpen) || this._closing) return;
			this._wantOpen = false;
			this._closing = true;
			this.classList.add("is-closing", "is-animating");
			document.removeEventListener("keyup", this._onKeyUp);

			var panel = this.panel || qs(this, ".mh-cd__panel");
			if (panel) void panel.offsetWidth;
			this.classList.remove("is-open");
			var finished = false;
			var done = function () {
				if (finished) return;
				finished = true;
				self._closing = false;
				self.classList.remove("is-closing", "is-animating");
				if (panel) panel.removeEventListener("transitionend", onEnd);
				if (!self._wantOpen) unlockPageScroll();
			};
			var onEnd = function (event) {
				if (event.target !== panel) return;
				if (event.propertyName && event.propertyName !== "transform") return;
				done();
			};
			if (panel) panel.addEventListener("transitionend", onEnd);
			setTimeout(done, CLOSE_MS);
		}

		setLoading(isLoading) {
			this.classList.toggle("is-loading", !!isLoading);
		}

		addItem(variantId, quantity, button) {
			var self = this;
			if (button) button.classList.add("is-loading");
			this.setLoading(true);
			this._internal = true;
			window.__mhCdForceAddon = true;
			fetch("/cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
			})
				.then(function (res) {
					return res.json().then(function (data) {
						if (!res.ok) throw data;
						return data;
					});
				})
				.then(function () {
					return self.refresh(true);
				})
				.catch(function (error) {
					var message = (error && (error.description || error.message)) || "Cart error";
					window.alert(message);
				})
				.finally(function () {
					self._internal = false;
					self.setLoading(false);
					if (button) button.classList.remove("is-loading");
				});
		}

		toggleAddon(row) {
			var self = this;
			if (!row || row.classList.contains("is-busy")) return;
			var variantId = row.getAttribute("data-variant-id");
			if (!variantId) return;
			var turnOn = !row.classList.contains("is-on");
			setAddonState(row.getAttribute("data-product-id"), turnOn ? "on" : "off");
			row.classList.add("is-busy");
			row.classList.toggle("is-on", turnOn);
			var switchBtn = qs(row, "[data-mh-cd-addon-toggle]");
			if (switchBtn) switchBtn.setAttribute("aria-checked", turnOn ? "true" : "false");

			this._internal = true;
			var request = turnOn
				? fetch("/cart/add.js", {
						method: "POST",
						headers: { "Content-Type": "application/json", Accept: "application/json" },
						body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
				  })
				: this._removeAddonFromCart(row, variantId);

			request
				.then(function (res) {
					return res.json().then(function (data) {
						if (!res.ok) throw data;
						return data;
					});
				})
				.then(function () {
					// Not forcing open: refresh keeps an open drawer open, and a default-on
					// add-on applied on page load must not pop the drawer in the customer's face.
					return self.refresh(false);
				})
				.catch(function (error) {
					row.classList.toggle("is-on", !turnOn);
					if (switchBtn) switchBtn.setAttribute("aria-checked", turnOn ? "false" : "true");
					var message = (error && (error.description || error.message)) || "Cart error";
					window.alert(message);
				})
				.finally(function () {
					self._internal = false;
					row.classList.remove("is-busy");
				});
		}

		_removeAddonFromCart(row, variantId) {
			var productId = String(row.getAttribute("data-product-id") || "");
			var variant = String(variantId || "");
			var hintedKey = row.getAttribute("data-key") || "";
			// A free-gift discount can split one variant into two lines. The variant id is
			// then ambiguous, and a line number from the drawer is stale. Use the current key.
			return fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
				.then(function (res) {
					return res.json();
				})
				.then(function (cart) {
					var items = (cart && cart.items) || [];
					var candidates = [];
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
						var props = item.properties || {};
						if (props._mh_gift || props._mh_pdp_addon) continue;
						var sameProduct = productId && String(item.product_id) === productId;
						var sameVariant = String(item.variant_id || item.id) === variant;
						if (sameProduct || sameVariant) candidates.push({ item: item, index: i });
					}
					var chosen = null;
					for (var c = 0; c < candidates.length; c++) {
						if (hintedKey && candidates[c].item.key === hintedKey) chosen = candidates[c];
					}
					if (!chosen) {
						for (var p = 0; p < candidates.length; p++) {
							if ((candidates[p].item.final_line_price || 0) > 0) {
								chosen = candidates[p];
								break;
							}
						}
					}
					if (!chosen && candidates.length) chosen = candidates[0];
					if (!chosen) {
						return new Response("{}", {
							status: 200,
							headers: { "Content-Type": "application/json" },
						});
					}
					var match = chosen.item;
					var index = chosen.index;
					function post(payload) {
						return fetch("/cart/change.js", {
							method: "POST",
							headers: { "Content-Type": "application/json", Accept: "application/json" },
							body: JSON.stringify(payload),
						});
					}
					if (!match.key) return post({ line: index + 1, quantity: 0 });
					return post({ id: String(match.key), quantity: 0 }).then(function (res) {
						if (res.ok) return res;
						return post({ line: index + 1, quantity: 0 });
					});
				});
		}

		updateQuantity(line, quantity) {
			var self = this;
			this.setLoading(true);
			this._internal = true;
			fetch("/cart/change.js", {
				method: "POST",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
			})
				.then(function (res) {
					return res.json();
				})
				.then(function () {
					return self.refresh(self.classList.contains("is-open") || self._wantOpen || self._closing === false);
				})
				.catch(function (error) {
					console.error(error);
				})
				.finally(function () {
					self._internal = false;
					self.setLoading(false);
				});
		}

		refresh(shouldOpen) {
			var self = this;
			if (this._refreshing) {
				if (shouldOpen) this._openAfterRefresh = true;
				return this._refreshing;
			}
			this._openAfterRefresh = !!shouldOpen;

			var wasOpen = this.classList.contains("is-open") || this._wantOpen;
			var currentHadIsOpen = this.classList.contains("is-open") || this._wantOpen;
			var oldPct = readProgressPct(this);

			this._internal = true;
			this._refreshing = fetch("/?section_id=" + SECTION_ID)
				.then(function (res) {
					return res.text();
				})
				.then(function (html) {
					var doc = new DOMParser().parseFromString(html, "text/html");
					var incoming = qs(doc, "mh-cart-drawer");
					var current = liveDrawer();
					if (!incoming || !current) return;
					var keepOpen = shouldOpen || wasOpen || self._openAfterRefresh;
					if (currentHadIsOpen) incoming.classList.add("is-open");
					current.replaceWith(incoming);
					var next = liveDrawer();
					if (!next) return;
					if (keepOpen) {
						if (currentHadIsOpen) {
							next._keepOpenWithoutAnimation();
						} else {
							next.open();
						}
						animateProgress(next, oldPct);
					}
					syncHeaderCartPrice();
				})
				.finally(function () {
					self._refreshing = null;
					self._internal = false;
					window.__mhCdJustRefreshed = Date.now();
					updateHeaderCart();
				});

			return this._refreshing;
		}
	}

	function bindGlobalCartTriggers() {
		if (window.__mhCartDrawerTriggers) return;
		window.__mhCartDrawerTriggers = true;
		document.addEventListener(
			"click",
			function (event) {
				var link = event.target.closest && event.target.closest(CART_LINK_SELECTOR);
				if (!link) return;
				if (link.closest && link.closest("mh-cart-drawer")) return;
				var drawer = liveDrawer();
				if (!drawer) return;
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
				if (typeof window.mhOpenCartDrawer === "function") {
					window.mhOpenCartDrawer();
				} else {
					drawer.open(link);
				}
			},
			true,
		);
	}

	function isInternalDrawerRequest() {
		var drawer = liveDrawer();
		return !!(drawer && drawer._internal);
	}


	function releasePdpAddonQueue() {
		window.__mhCdPdpAddonQueued = false;
		window.__mhCdPdpAddonQueuedId = "";
		if (window.__mhCdPdpAddonTimer) {
			window.clearTimeout(window.__mhCdPdpAddonTimer);
			window.__mhCdPdpAddonTimer = 0;
		}
	}

	function rememberCart(cart) {
		window.__mhCdLastCart = cart;
		var queued = String(window.__mhCdPdpAddonQueuedId || "");
		if (!queued || !cart || !cart.items) return;
		for (var i = 0; i < cart.items.length; i++) {
			var line = cart.items[i];
			if (String(line.variant_id || line.id) === queued) {
				releasePdpAddonQueue();
				return;
			}
		}
	}

	function pdpAddonMarker() {
		var node = document.querySelector("[data-mh-pdp-variants]");
		if (!node) return null;
		var addonId = String(node.getAttribute("data-mh-pdp-addon") || "");
		if (!/^\d+$/.test(addonId)) return null;
		var variants = {};
		String(node.getAttribute("data-mh-pdp-variants") || "").split(",").forEach(function (id) {
			if (/^\d+$/.test(id)) variants[id] = true;
		});
		if (!Object.keys(variants).length) return null;
		return { addonId: addonId, variants: variants };
	}

	function variantPresent(variantId) {
		var id = String(variantId);
		if (window.__mhCdPdpAddonQueued && String(window.__mhCdPdpAddonQueuedId) === id) return true;
		var cart = window.__mhCdLastCart;
		if (cart && cart.items) {
			for (var i = 0; i < cart.items.length; i++) {
				var line = cart.items[i];
				if (String(line.variant_id || line.id) === id) return true;
			}
		}
		var nodes = document.querySelectorAll("mh-cart-drawer [data-variant-id]");
		for (var j = 0; j < nodes.length; j++) {
			if (nodes[j].getAttribute("data-variant-id") === id) return true;
		}
		return false;
	}

	function itemsFromJson(data) {
		if (!data || typeof data !== "object") return [];
		var source = Array.isArray(data.items) && data.items.length ? data.items : null;
		if (!source && data.id) source = [data];
		if (!source) return [];
		return source.map(function (item) {
			var properties = item.properties && typeof item.properties === "object" ? item.properties : null;
			return {
				id: String(item.id || item.variant_id || ""),
				quantity: parseInt(item.quantity, 10) || 1,
				properties: properties,
				selling_plan: item.selling_plan || null
			};
		}).filter(function (item) { return /^\d+$/.test(item.id); });
	}

	function itemsFromQuery(query) {
		var params;
		try { params = new URLSearchParams(query); } catch (e) { return []; }
		var grouped = {};
		var hasItems = false;
		params.forEach(function (value, key) {
			var match = key.match(/^items\[(\d+)\]\[id\]$/);
			if (!match) return;
			hasItems = true;
			grouped[match[1]] = { id: value, quantity: 1, properties: null, selling_plan: null };
		});
		if (hasItems) {
			return Object.keys(grouped).sort(function (a, b) { return Number(a) - Number(b); }).map(function (index) {
				var item = grouped[index];
				var qty = params.get("items[" + index + "][quantity]");
				if (qty) item.quantity = parseInt(qty, 10) || 1;
				var plan = params.get("items[" + index + "][selling_plan]");
				if (plan) item.selling_plan = plan;
				params.forEach(function (value, key) {
					var prop = key.match(new RegExp("^items\\[" + index + "\\]\\[properties\\]\\[(.+)\\]$"));
					if (!prop) return;
					item.properties = item.properties || {};
					item.properties[prop[1]] = value;
				});
				return item;
			}).filter(function (item) { return /^\d+$/.test(String(item.id)); });
		}
		var id = params.get("id");
		if (!/^\d+$/.test(String(id || ""))) return [];
		var properties = null;
		params.forEach(function (value, key) {
			var match = key.match(/^properties\[(.+)\]$/);
			if (!match) return;
			properties = properties || {};
			properties[match[1]] = value;
		});
		return [{
			id: String(id),
			quantity: parseInt(params.get("quantity"), 10) || 1,
			properties: properties,
			selling_plan: params.get("selling_plan") || null
		}];
	}

	function leftoverQuery(query) {
		var params = new URLSearchParams(query);
		var parts = [];
		params.forEach(function (value, key) {
			if (key === "id" || key === "quantity" || key === "selling_plan") return;
			if (key.indexOf("properties[") === 0 || key.indexOf("items[") === 0) return;
			parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
		});
		return parts;
	}

	function jsonExtras(data) {
		var extras = {};
		if (!data || typeof data !== "object" || Array.isArray(data)) return extras;
		Object.keys(data).forEach(function (key) {
			if (key === "id" || key === "quantity" || key === "properties" || key === "selling_plan" || key === "items") return;
			extras[key] = data[key];
		});
		return extras;
	}

	function parseAddPayload(body) {
		if (body == null) return null;
		if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
			var asQuery = body.toString();
			return { kind: "form", items: itemsFromQuery(asQuery), extra: leftoverQuery(asQuery) };
		}
		if (typeof FormData !== "undefined" && body instanceof FormData) {
			var hasFile = false;
			var query = new URLSearchParams();
			body.forEach(function (value, key) {
				if (typeof File !== "undefined" && value instanceof File && value.name) hasFile = true;
				else if (typeof value === "string") query.append(key, value);
			});
			if (hasFile) return null;
			var queryText = query.toString();
			return { kind: "form", items: itemsFromQuery(queryText), extra: leftoverQuery(queryText) };
		}
		if (typeof body === "string") {
			var trimmed = body.replace(/^\uFEFF/, "").trim();
			if (!trimmed) return null;
			if (trimmed.charAt(0) === "{") {
				try {
					var data = JSON.parse(trimmed);
					return { kind: "json", items: itemsFromJson(data), extra: jsonExtras(data) };
				} catch (e) {
					return null;
				}
			}
			return { kind: "form", items: itemsFromQuery(trimmed), extra: leftoverQuery(trimmed) };
		}
		if (typeof body === "object") {
			return { kind: "json", items: itemsFromJson(body), extra: jsonExtras(body) };
		}
		return null;
	}

	function encodeAddPayload(parsed) {
		if (parsed.kind === "json") {
			var payload = parsed.extra || {};
			payload.items = parsed.items.map(function (item) {
				var line = { id: Number(item.id), quantity: item.quantity || 1 };
				if (item.properties) line.properties = item.properties;
				if (item.selling_plan) line.selling_plan = item.selling_plan;
				return line;
			});
			return { body: JSON.stringify(payload), contentType: "application/json" };
		}
		var parts = [];
		parsed.items.forEach(function (item, index) {
			parts.push("items[" + index + "][id]=" + encodeURIComponent(item.id));
			parts.push("items[" + index + "][quantity]=" + encodeURIComponent(item.quantity || 1));
			if (item.selling_plan) {
				parts.push("items[" + index + "][selling_plan]=" + encodeURIComponent(item.selling_plan));
			}
			if (item.properties) {
				Object.keys(item.properties).forEach(function (key) {
					var safeKey = /^[\w .\-+]+$/.test(key) ? key : encodeURIComponent(key);
					parts.push("items[" + index + "][properties][" + safeKey + "]=" + encodeURIComponent(item.properties[key]));
				});
			}
		});
		if (parsed.extra && parsed.extra.length) parts = parts.concat(parsed.extra);
		return { body: parts.join("&"), contentType: "application/x-www-form-urlencoded; charset=UTF-8" };
	}

	function addsCurrentProduct(items, marker) {
		for (var i = 0; i < items.length; i++) {
			if (marker.variants[String(items[i].id)]) return true;
		}
		return false;
	}

	function payloadHasVariant(items, id) {
		id = String(id);
		for (var i = 0; i < items.length; i++) {
			if (String(items[i].id) === id) return true;
		}
		return false;
	}

	function attachPdpAddon(body) {
		if (isInternalDrawerRequest()) return null;
		var marker = pdpAddonMarker();
		if (!marker) return null;
		var parsed = parseAddPayload(body);
		if (!parsed || !parsed.items.length) return null;
		if (!addsCurrentProduct(parsed.items, marker)) return null;
		if (payloadHasVariant(parsed.items, marker.addonId)) return null;
		if (variantPresent(marker.addonId)) return null;
		parsed.items.push({
			id: marker.addonId,
			quantity: 1,
			properties: { _mh_pdp_addon: "1" },
			selling_plan: null
		});
		window.__mhCdPdpAddonQueued = true;
		window.__mhCdPdpAddonQueuedId = marker.addonId;
		window.clearTimeout(window.__mhCdPdpAddonTimer);
		window.__mhCdPdpAddonTimer = window.setTimeout(releasePdpAddonQueue, 8000);
		return encodeAddPayload(parsed);
	}

	function bindAjaxIntercepts() {
		if (window.__mhCartDrawerIntercepts) return;
		window.__mhCartDrawerIntercepts = true;

		if (window.jQuery) {
			window.jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
				if (isInternalDrawerRequest()) return;
				var url = (settings && settings.url) || "";
				if (url.indexOf("/cart/add") !== -1) {
					onExternalCartAdd();
				}
				// ajaxify-cart writes #CartCost from /cart.js, which ignores discount-code cookies.
				// This runs after that write, so the header is put back to the drawer total.
				if (url.indexOf("/cart.js") !== -1 || url.indexOf("/cart/add") !== -1) {
					syncHeaderCartPrice();
				}
			});
		}

		if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__mhCdOpen) {
			var xhrOpen = XMLHttpRequest.prototype.open;
			var xhrSend = XMLHttpRequest.prototype.send;
			XMLHttpRequest.prototype.open = function (method, url) {
				this.__mhCdUrl = url ? String(url) : "";
				return xhrOpen.apply(this, arguments);
			};
			XMLHttpRequest.prototype.send = function (body) {
				var originalBody = body;
				if (this.__mhCdUrl && this.__mhCdUrl.indexOf("/cart/add") !== -1) {
					var rewritten = null;
					if (!isInternalDrawerRequest()) {
						try { rewritten = attachPdpAddon(body); } catch (e) { rewritten = null; }
					}
					if (rewritten) {
						body = rewritten.body;
						this.__mhCdPdpAddon = true;
						if (rewritten.contentType && typeof FormData !== "undefined" && originalBody instanceof FormData) {
							try { this.setRequestHeader("Content-Type", rewritten.contentType); } catch (e) {}
						}
					}
					this.addEventListener("load", function () {
						if (this.__mhCdPdpAddon && (this.status < 200 || this.status >= 300)) releasePdpAddonQueue();
						if (isInternalDrawerRequest()) return;
						if (this.status >= 200 && this.status < 300) {
							onExternalCartAdd();
						}
					});
					this.addEventListener("error", function () {
						if (this.__mhCdPdpAddon) releasePdpAddonQueue();
					});
					this.addEventListener("abort", function () {
						if (this.__mhCdPdpAddon) releasePdpAddonQueue();
					});
				}
				return xhrSend.call(this, body);
			};
			XMLHttpRequest.prototype.__mhCdOpen = true;
		}

		if (!window.fetch) return;
		var originalFetch = window.fetch;
		window.fetch = function (resource, init) {
			var url = typeof resource === "string" ? resource : resource && resource.url;
			// Bundles Bear assigns window.location.href on the line after its own /discount call
			// resolves. Seeing that call while waiting for a code means the app skipped the exit
			// it was steered into, so the request is sent but its promise is left pending: that is
			// the only way to stop a redirect, and the discount still lands on the cart.
			if (window.__mhCdBundleAwaitingCode && url && url.indexOf("/discount/") !== -1) {
				originalFetch.apply(this, arguments).catch(function () {});
				return new Promise(function () {});
			}
			var fetchResource = resource;
			var fetchInit = init;
			var queuedAddon = false;
			if (url && url.indexOf("/cart/add") !== -1 && init && !isInternalDrawerRequest()) {
				var rewritten = null;
				try { rewritten = attachPdpAddon(init.body); } catch (e) { rewritten = null; }
				if (rewritten) {
					queuedAddon = true;
					var headers = new Headers(init.headers || undefined);
					if (rewritten.contentType) headers.set("Content-Type", rewritten.contentType);
					fetchInit = Object.assign({}, init, { body: rewritten.body, headers: headers });
				}
			}
			return originalFetch.call(this, fetchResource, fetchInit).then(function (response) {
				if (queuedAddon && !response.ok) releasePdpAddonQueue();
				if (isInternalDrawerRequest()) return response;
				if (url && url.indexOf("/cart/add") !== -1 && response.ok) {
					onExternalCartAdd();
				}
				return response;
			}, function (error) {
				if (queuedAddon) releasePdpAddonQueue();
				throw error;
			});
		};
	}

	function stayInDrawerInsteadOfCartPage() {
		return typeof window.mhOpenCartDrawer === "function" && window.mhOpenCartDrawer();
	}

	function readAddonStates() {
		try {
			return JSON.parse(sessionStorage.getItem(ADDON_STATE_KEY) || "{}");
		} catch (e) {
			return {};
		}
	}

	function writeAddonStates(states) {
		try {
			sessionStorage.setItem(ADDON_STATE_KEY, JSON.stringify(states));
		} catch (e) {}
	}

	function setAddonState(productId, state) {
		if (!productId) return;
		var states = readAddonStates();
		states[productId] = state;
		writeAddonStates(states);
	}

	function addonProductIds() {
		var ids = {};
		qsa(document, "[data-mh-cd-addon]").forEach(function (row) {
			var id = row.getAttribute("data-product-id");
			if (id) ids[String(id)] = true;
		});
		return ids;
	}

	function cartIsOnlyAddons(cart) {
		if (!cart || !cart.items || !cart.items.length) return false;
		var ids = addonProductIds();
		if (!Object.keys(ids).length) return false;
		for (var i = 0; i < cart.items.length; i++) {
			if (!ids[String(cart.items[i].product_id)]) return false;
		}
		return true;
	}

	function clearAddonOnlyCart() {
		if (window.__mhCdClearingAddons) return Promise.resolve();
		window.__mhCdClearingAddons = true;
		window.__mhCdForceAddon = false;
		writeAddonStates({});
		return fetch("/cart/clear.js", {
			method: "POST",
			headers: { Accept: "application/json" },
		})
			.then(function () {
				var empty = { items: [], item_count: 0, total_price: 0, total_discount: 0 };
				rememberCart(empty);
				qsa(document, "[data-mh-header-cart-count], [data-count], .item__count, #CartCount span, .cart-count, .item-count").forEach(function (el) {
					el.textContent = "0";
				});
				var countWrap = document.getElementById("CartCount");
				if (countWrap) countWrap.classList.add("hidden-count");
				var drawer = liveDrawer();
				if (drawer && typeof drawer.refresh === "function") {
					return drawer.refresh(drawer.classList.contains("is-open") || !!drawer._wantOpen);
				}
				notifyCartUpdated(empty);
				syncHeaderCartPrice(empty);
			})
			.finally(function () {
				window.__mhCdClearingAddons = false;
			});
	}

	// A newly added product turns a default-on add-on back on, even if it was switched off.
	// Switching it off still sticks until the next product add. An add-on is never left as the
	// only line: that cart is cleared.
	function syncDefaultAddons(cart) {
		if (!cart || !cart.items || !cart.items.length) {
			writeAddonStates({});
			return;
		}

		var rows = qsa(document, '[data-mh-cd-addon][data-default-on="true"]');
		if (!rows.length) return;

		var force = !!window.__mhCdForceAddon;
		window.__mhCdForceAddon = false;
		if (force) {
			var stored = readAddonStates();
			var changed = false;
			rows.forEach(function (row) {
				var id = row.getAttribute("data-product-id");
				if (id && stored[id] === "off") {
					delete stored[id];
					changed = true;
				}
			});
			if (changed) writeAddonStates(stored);
		}

		var states = readAddonStates();
		for (var i = 0; i < rows.length; i += 1) {
			var row = rows[i];
			var productId = row.getAttribute("data-product-id");
			if (!productId) continue;
			var inCart = cart.items.some(function (item) {
				return String(item.product_id) === String(productId);
			});
			if (inCart || row.classList.contains("is-on")) {
				if (states[productId] !== "on") setAddonState(productId, "on");
				continue;
			}
			if (states[productId] || row.classList.contains("is-busy")) continue;
			var otherLines = cart.items.filter(function (item) {
				return String(item.product_id) !== String(productId);
			});
			if (!otherLines.length) continue;
			var drawer = row.closest("mh-cart-drawer");
			if (!drawer || typeof drawer.toggleAddon !== "function") continue;
			setAddonState(productId, "on");
			drawer.toggleAddon(row);
			return;
		}
	}

	function cartSignature(cart) {
		if (!cart) return "";
		return [cart.item_count, cart.total_price, cart.total_discount, cart.items && cart.items.length].join("-");
	}
	function formatShippingMoney(cents) {
		if (typeof formatCartMoney === "function") return formatCartMoney(cents);
		if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
			return theme.Currency.formatMoney(cents, theme.moneyFormat);
		}
		if (window.Shopify && typeof Shopify.formatMoney === "function") {
			return Shopify.formatMoney(cents);
		}
		return (cents / 100).toFixed(2);
	}

	function shippingFreeLabel(row) {
		return (row && row.getAttribute("data-free-label")) || "Free";
	}

	var SHIPPING_COUNTRY_ISO = {
		netherlands: "NL",
		nederland: "NL",
		holland: "NL",
		germany: "DE",
		deutschland: "DE",
		duitsland: "DE",
		tyskland: "DE",
		sweden: "SE",
		sverige: "SE",
		zweden: "SE",
		norway: "NO",
		norge: "NO",
		noorwegen: "NO",
		italy: "IT",
		italia: "IT",
		italien: "IT",
		belgie: "BE",
		belgium: "BE",
		belgien: "BE",
		austria: "AT",
		osterreich: "AT",
		denmark: "DK",
		danmark: "DK",
		france: "FR",
		frankrike: "FR",
		frankreich: "FR",
		finland: "FI",
		suomi: "FI",
	};
	var SHIPPING_DEFAULT_ZIP = {
		NL: "1012AB",
		DE: "10115",
		SE: "11122",
		NO: "0150",
		IT: "00184",
		BE: "1000",
		AT: "1010",
		DK: "1050",
		FR: "75001",
		FI: "00100",
	};
	// Italy rejects a postcode with no province: rates come back empty and checkout
	// keeps that address, so the cart cannot be delivered. 00184 is Rome.
	var SHIPPING_DEFAULT_PROVINCE = {
		IT: "RM",
	};

	function shippingCountryIso(value) {
		var raw = String(value || "").trim();
		if (!raw) return "";
		if (/^[A-Za-z]{2}$/.test(raw)) return raw.toUpperCase();
		var key = raw
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.replace(/[^a-z]/g, "");
		return SHIPPING_COUNTRY_ISO[key] || "";
	}

	function shippingRatesQuery(row) {
		var params = [];
		var country = shippingCountryIso(row.getAttribute("data-country"));
		// A name Shopify does not accept is still written onto the cart. Checkout then
		// tells the customer the product cannot be delivered there, and the drawer
		// never receives a rate. Skip the lookup instead of sending that address.
		if (!/^[A-Z]{2}$/.test(country)) return "";
		var province = row.getAttribute("data-province") || "";
		var zip = (row.getAttribute("data-zip") || "").trim();
		var usedDefaultZip = false;
		if (!zip && SHIPPING_DEFAULT_ZIP[country]) {
			zip = SHIPPING_DEFAULT_ZIP[country];
			usedDefaultZip = true;
		}
		if (!province && usedDefaultZip && SHIPPING_DEFAULT_PROVINCE[country]) {
			province = SHIPPING_DEFAULT_PROVINCE[country];
		}
		if (!zip) return "";
		params.push("shipping_address[country]=" + encodeURIComponent(country));
		if (province) params.push("shipping_address[province]=" + encodeURIComponent(province));
		params.push("shipping_address[zip]=" + encodeURIComponent(zip));
		return params.join("&");
	}

	function pickShippingRate(rates) {
		if (!rates || !rates.length) return null;
		// Checkout lists every rate; the cost customers actually pay is the cheapest one, and
		// a 0.00 rate is how Shopify marks free shipping.
		return rates.reduce(function (best, rate) {
			return (parseFloat(rate.price) || 0) < (parseFloat(best.price) || 0) ? rate : best;
		});
	}

	function writeShippingValue(text) {
		var live = document.querySelector("[data-mh-cd-shipping-value]");
		if (live) live.textContent = text;
		return text;
	}

	function cartRequiresShipping(row, cart) {
		if (cart && cart.items) {
			return cart.items.some(function (item) {
				return item.requires_shipping;
			});
		}
		return row.getAttribute("data-requires-shipping") !== "false";
	}

	function cartQualifiesForFreeShipping(row) {
		var min = parseInt(row.getAttribute("data-free-min"), 10) || 0;
		var total = parseInt(row.getAttribute("data-cart-total"), 10) || 0;
		return min > 0 && total >= min;
	}

	function parseRatesPayload(data) {
		var rates = data && data.shipping_rates;
		if (Array.isArray(rates)) return rates;
		return null;
	}

	function pollAsyncShippingRates(query, tries) {
		return fetch("/cart/async_shipping_rates.json?" + query, { credentials: "same-origin" })
			.then(function (res) {
				return res.json();
			})
			.then(function (data) {
				var rates = data && data.shipping_rates;
				if (rates && rates.pending && tries < 8) {
					return new Promise(function (resolve) {
						window.setTimeout(function () {
							resolve(pollAsyncShippingRates(query, tries + 1));
						}, 400);
					});
				}
				return Array.isArray(rates) ? rates : [];
			});
	}

	function fetchCheckoutShippingRates(query) {
		return fetch("/cart/shipping_rates.json?" + query, { credentials: "same-origin" })
			.then(function (res) {
				return res.json().then(function (data) {
					if (!res.ok) throw data;
					return data;
				});
			})
			.then(function (data) {
				var rates = parseRatesPayload(data);
				if (rates && rates.length) return rates;
				// GET can answer before carrier rates are ready. Preparing the same
				// destination again is safe only after that GET succeeded: a failed
				// lookup has already stored the address, and repeating it is what
				// makes checkout reject the cart.
				return fetch("/cart/prepare_shipping_rates.json?" + query, {
					method: "POST",
					credentials: "same-origin",
				}).then(function (res) {
					if (!res.ok) throw new Error("shipping");
					return pollAsyncShippingRates(query, 0);
				});
			});
	}

	// Free shipping uses the section label. A paid figure comes from the same rates checkout
	// uses. Liquid cart.total_price is the discounted one, so a threshold gift / discount code
	// that unlocks free shipping is visible here even when /cart.js still shows the old total.
	function refreshShippingEstimate(cart) {
		var row = document.querySelector("[data-mh-cd-shipping]");
		if (!row) return;
		var valueEl = row.querySelector("[data-mh-cd-shipping-value]");
		if (!valueEl) return;

		if (!cartRequiresShipping(row, cart) || cartQualifiesForFreeShipping(row)) {
			writeShippingValue(shippingFreeLabel(row));
			return;
		}

		var query = shippingRatesQuery(row);
		if (!query) {
			writeShippingValue(row.getAttribute("data-fallback") || "");
			return;
		}

		var cacheKey = [row.getAttribute("data-cart-total") || "", cart && cartSignature(cart), query].join("|");
		if (window.__mhCdShippingKey === cacheKey && window.__mhCdShippingText != null) {
			writeShippingValue(window.__mhCdShippingText);
			return;
		}
		if (window.__mhCdShippingFetch && window.__mhCdShippingFetchKey === cacheKey) return;

		window.__mhCdShippingFetchKey = cacheKey;
		window.__mhCdShippingFetch = fetchCheckoutShippingRates(query)
			.then(function (rates) {
				var rate = pickShippingRate(rates);
				var text;
				if (!rate) {
					text = row.getAttribute("data-fallback") || "";
				} else if (!(parseFloat(rate.price) > 0)) {
					text = shippingFreeLabel(row);
				} else {
					text = formatShippingMoney(Math.round(parseFloat(rate.price) * 100));
				}
				window.__mhCdShippingKey = cacheKey;
				window.__mhCdShippingText = text;
				writeShippingValue(text);
			})
			.catch(function () {
				writeShippingValue(row.getAttribute("data-fallback") || "");
			})
			.finally(function () {
				window.__mhCdShippingFetch = null;
			});
	}

	function scheduleDiscountAwareRefresh() {
		if (window.__mhCdDiscountPoll) return;
		window.__mhCdDiscountPoll = true;
		var lastSig = "";
		var tries = 0;
		function poll() {
			tries += 1;
			fetch("/cart.js")
				.then(function (res) {
					return res.json();
				})
				.then(function (cart) {
					var sig = cartSignature(cart);
					if (sig && sig !== lastSig) {
						lastSig = sig;
						if (tries > 1) {
							var drawer = liveDrawer();
							if (drawer && typeof drawer.refresh === "function") drawer.refresh(true);
						}
					}
					if (tries < 6) {
						window.setTimeout(poll, 450);
					} else {
						window.__mhCdDiscountPoll = false;
					}
				})
				.catch(function () {
					window.__mhCdDiscountPoll = false;
				});
		}
		window.setTimeout(poll, 300);
	}

	// Bundles Bear normally hands out its discount code only as part of a redirect: applyDiscount
	// asks its backend for the code and then assigns window.location.href, which a theme cannot
	// cancel. It does have one exit that stops right after the code is known and leaves it on
	// window.bundlesBear, but that exit is only taken when the sibling Upsell Bear app reports a
	// campaign. Standing in for that app is what lets the code be applied while staying here.
	var UPSELL_STUB_STATUS = "mh-cart-drawer";
	var BUNDLE_CODE_TIMEOUT_MS = 9000;

	function installUpsellStub() {
		if (window.conversionBearUpsell) return false;
		// Neither "exists" nor "not_exists" on purpose: the first makes the app open an upsell
		// funnel instead of calling our hook, the second puts the redirect back.
		window.conversionBearUpsell = {
			getCampaignStatus: function () {
				return UPSELL_STUB_STATUS;
			},
		};
		return true;
	}

	function removeUpsellStub() {
		var stub = window.conversionBearUpsell;
		if (!stub || typeof stub.getCampaignStatus !== "function") return;
		if (stub.getCampaignStatus() !== UPSELL_STUB_STATUS) return;
		try {
			delete window.conversionBearUpsell;
		} catch (e) {
			window.conversionBearUpsell = undefined;
		}
	}

	function applyBundleDiscountCode(code) {
		fetch("/discount/" + encodeURIComponent(code))
			.then(function () {
				var drawer = liveDrawer();
				if (drawer && typeof drawer.refresh === "function") drawer.refresh(true);
			})
			.catch(function () {});
	}

	function clearBundleDiscountWait() {
		if (!window.__mhCdBundleWait) return;
		window.clearInterval(window.__mhCdBundleWait);
		window.__mhCdBundleWait = 0;
	}

	function requestBundleDiscount() {
		if (window.__mhCdBundleRequesting) return true;
		var bear = window.bundlesBear;
		if (!bear || typeof bear.applyDiscount !== "function") {
			// Theme ATC can win the race against the widget boot. Keep asking for a short while.
			if (window.__mhCdBundleWait) return false;
			var tries = 0;
			window.__mhCdBundleWait = window.setInterval(function () {
				tries += 1;
				if (requestBundleDiscount() || tries > 20) clearBundleDiscountWait();
			}, 250);
			return false;
		}

		clearBundleDiscountWait();
		window.__mhCdBundleRequesting = true;
		var stubbed = installUpsellStub();
		window.__mhCdBundleAwaitingCode = true;
		function release() {
			window.__mhCdBundleRequesting = false;
			window.__mhCdBundleAwaitingCode = false;
			if (!stubbed) return;
			stubbed = false;
			removeUpsellStub();
		}

		try {
			// A falsy second argument is what routes the app into the non-redirecting exit.
			bear.applyDiscount(null, false);
		} catch (e) {
			release();
			return false;
		}

		var deadline = Date.now() + BUNDLE_CODE_TIMEOUT_MS;
		(function poll() {
			// The app replaces window.bundlesBear wholesale on every state change.
			var state = window.bundlesBear || {};
			if (state.discountStatus === "loaded" && state.code) {
				release();
				applyBundleDiscountCode(state.code);
				return;
			}
			if (state.discountStatus === "failed" || Date.now() > deadline) {
				release();
				return;
			}
			window.setTimeout(poll, 200);
		})();
		return true;
	}

	function onExternalCartAdd() {
		window.__mhCdForceAddon = true;
		window.mhOpenCartDrawer();
		scheduleDiscountAwareRefresh();
		requestBundleDiscount();
	}

	function bindBundleBearHooks() {
		if (window.__mhCdBundleBear) return;
		window.__mhCdBundleBear = true;

		// Returning false is the app's only "stay on this page" escape hatch, and it also skips
		// the app's discount step, so that step is driven from here instead.
		var previousAccept = window.cbOnAcceptOffer;
		window.cbOnAcceptOffer = function (payload) {
			if (typeof previousAccept === "function") {
				try {
					previousAccept(payload);
				} catch (e) {}
			}
			if (!liveDrawer()) return true;
			onExternalCartAdd();
			return false;
		};
	}

	window.mhOpenCartDrawer = function () {
		var drawer = liveDrawer();
		if (!drawer) return false;
		if (typeof drawer.open !== "function") {
			// Element is still waiting to be upgraded, retry once it is registered.
			if (window.customElements && customElements.whenDefined) {
				customElements.whenDefined("mh-cart-drawer").then(function () {
					window.mhOpenCartDrawer();
				});
			}
			return true;
		}
		if (drawer._refreshing) {
			drawer._openAfterRefresh = true;
			return true;
		}
		if (
			window.__mhCdJustRefreshed &&
			Date.now() - window.__mhCdJustRefreshed < 500 &&
			(drawer.classList.contains("is-open") || drawer._wantOpen)
		) {
			return true;
		}
		if (typeof drawer.refresh === "function") {
			drawer.refresh(true);
		} else if (!drawer.classList.contains("is-open") && !drawer._wantOpen) {
			drawer.open();
		}
		return true;
	};

	function checkoutUrl() {
		var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
		if (root.charAt(root.length - 1) !== "/") root += "/";
		return root + "checkout";
	}

	function isCartPagePath() {
		var path = window.location.pathname.replace(/\/+$/, "") || "/";
		return path === "/cart" || path.slice(-5) === "/cart";
	}

	function drawerIsOpen() {
		var drawer = liveDrawer();
		return !!(drawer && (drawer.classList.contains("is-open") || drawer._wantOpen));
	}

	function releaseDrawerPageState() {
		unlockPageScroll();
		var drawer = liveDrawer();
		if (!drawer) return;
		drawer._wantOpen = false;
		drawer._closing = false;
		drawer.classList.remove("is-open", "is-closing");
	}

	function markLeavingForCheckout() {
		window.__mhCdNavigatingAway = true;
	}

	function cartIsOnlyFreeEbook() {
		var drawer = liveDrawer();
		if (!drawer) return false;
		var items = drawer.querySelectorAll(".mh-cd__item");
		if (!items.length) return false;
		for (var i = 0; i < items.length; i++) {
			if (!items[i].hasAttribute("data-mh-cd-free")) return false;
		}
		return true;
	}

	function freeEbookCheckoutError(checkout) {
		var drawer = (checkout && checkout.closest && checkout.closest("mh-cart-drawer")) || liveDrawer();
		return drawer ? drawer.querySelector("[data-mh-cd-checkout-error]") : null;
	}

	function bindCheckoutNavigation() {
		if (window.__mhCdCheckoutNav) return;
		window.__mhCdCheckoutNav = true;
		document.addEventListener(
			"click",
			function (event) {
				var checkout = event.target.closest && event.target.closest("#MHCartDrawer-Checkout, .mh-cd__checkout");
				if (!checkout) return;
				event.preventDefault();
				if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
				var error = freeEbookCheckoutError(checkout);
				if (cartIsOnlyFreeEbook()) {
					if (error) error.hidden = false;
					return;
				}
				if (error) error.hidden = true;
				markLeavingForCheckout();
				window.location.assign(checkout.getAttribute("href") || checkoutUrl());
			},
			true,
		);
	}

	// Returning from checkout can restore this page from the bfcache or the HTTP cache, in which
	// case the rendered drawer still describes the cart as it was before checkout touched it.
	// Comparing the markup's signature against the live cart catches that without refreshing on
	// every back navigation.
	function resyncDrawerAfterRestore(cart, shouldOpen) {
		if (!cart) return;
		var drawer = liveDrawer();
		if (!drawer || typeof drawer.refresh !== "function") return;
		var rendered = drawer.getAttribute("data-cart-signature");
		if (rendered && rendered === cartSignature(cart)) return;
		var refreshing = drawer.refresh(shouldOpen);
		if (!refreshing || typeof refreshing.then !== "function") return;
		refreshing.then(function () {
			var restored = liveDrawer();
			if (restored && restored.classList.contains("is-empty") && typeof restored.close === "function") {
				restored.close();
			}
		});
	}

	function isHistoryRestore(event) {
		if (event && event.persisted) return true;
		try {
			var nav = performance.getEntriesByType("navigation")[0];
			return !!(nav && nav.type === "back_forward");
		} catch (e) {
			return false;
		}
	}

	function bindHistoryRestore() {
		if (window.__mhCdHistoryRestore) return;
		window.__mhCdHistoryRestore = true;
		window.addEventListener("pageshow", function (event) {
			window.__mhCdNavigatingAway = false;
			var restored = isHistoryRestore(event);
			if (restored) {
				document.documentElement.classList.add("mh-cd-restore");
				qsa(document, "mh-cart-drawer").forEach(function (el) {
					el.classList.remove("is-animating", "is-closing");
				});
				setTimeout(function () {
					document.documentElement.classList.remove("mh-cd-restore");
				}, 500);
			}
			var drawer = liveDrawer();
			if (drawer && typeof drawer.setLoading === "function") drawer.setLoading(false);

			var wasOpen = drawerIsOpen();
			if (!wasOpen) releaseDrawerPageState();
			// A normal load already has fresh section HTML. Replacing the open drawer on the
			// way back from checkout is what flashed it shut and open again, so that replace
			// only runs for a real back/forward restore.
			updateHeaderCart().then(function (cart) {
				if (!isHistoryRestore(event)) return;
				resyncDrawerAfterRestore(cart, wasOpen);
			});
		});
	}


	function cartEscapeTarget() {
		try {
			var stored = sessionStorage.getItem("mhCdLastPage");
			if (stored) {
				var last = new URL(stored, window.location.origin);
				var lastPath = last.pathname.replace(/\/+$/, "") || "/";
				var lastIsCart = lastPath === "/cart" || lastPath.slice(-5) === "/cart";
				if (last.origin === window.location.origin && !lastIsCart && lastPath.indexOf("/checkout") === -1) {
					return last.href;
				}
			}
		} catch (e) {}
		try {
			if (document.referrer) {
				var ref = new URL(document.referrer, window.location.origin);
				if (ref.origin === window.location.origin) {
					var refPath = ref.pathname.replace(/\/+$/, "") || "/";
					var refIsCart = refPath === "/cart" || refPath.slice(-5) === "/cart";
					if (!refIsCart && refPath.indexOf("/checkout") === -1) return ref.href;
				}
			}
		} catch (e) {}
		return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
	}

	function escapeCartPage() {
		if (window.Shopify && window.Shopify.designMode) return;
		if (!liveDrawer()) return;
		var now = Date.now();
		try {
			var last = parseInt(sessionStorage.getItem("mhCdCartEscapeAt") || "0", 10);
			if (last && now - last < 4000) return;
			sessionStorage.setItem("mhCdCartEscapeAt", String(now));
			sessionStorage.setItem("mhCdOpenOnLoad", "1");
		} catch (e) {}
		window.location.replace(cartEscapeTarget());
	}

	function reopenDrawerAfterCartEscape() {
		var flag = null;
		try {
			flag = sessionStorage.getItem("mhCdOpenOnLoad");
			sessionStorage.removeItem("mhCdOpenOnLoad");
		} catch (e) {}
		if (!flag) return;
		if (typeof window.mhOpenCartDrawer === "function") window.mhOpenCartDrawer();
	}

	function initCartPageHandoff() {
		if (window.__mhCdCartHandoff) return;
		window.__mhCdCartHandoff = true;

		function run() {
			if (isCartPagePath()) {
				escapeCartPage();
				return;
			}
			reopenDrawerAfterCartEscape();
		}

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", run);
		} else {
			run();
		}
	}

	function bindCartPageRedirectGuard() {
		if (window.__mhCartDrawerRedirectGuard) return;
		window.__mhCartDrawerRedirectGuard = true;

		function blockCartNavigation(url) {
			if (window.__mhCdNavigatingAway) return false;
			return isCartPageUrl(url) && stayInDrawerInsteadOfCartPage();
		}

		try {
			var proto = window.Location && Location.prototype;
			var desc = proto && Object.getOwnPropertyDescriptor(proto, "href");
			if (desc && desc.set && desc.get) {
				Object.defineProperty(proto, "href", {
					configurable: true,
					enumerable: true,
					get: function () {
						return desc.get.call(this);
					},
					set: function (url) {
						if (blockCartNavigation(url)) return;
						return desc.set.call(this, url);
					},
				});
			}
		} catch (e) {}

		try {
			var locDesc = Object.getOwnPropertyDescriptor(window.location, "href") ||
				(window.Location && Object.getOwnPropertyDescriptor(Location.prototype, "href"));
			if (locDesc && locDesc.set && locDesc.get) {
				Object.defineProperty(window.location, "href", {
					configurable: true,
					enumerable: true,
					get: function () {
						return locDesc.get.call(window.location);
					},
					set: function (url) {
						if (blockCartNavigation(url)) return;
						return locDesc.set.call(window.location, url);
					},
				});
			}
		} catch (e) {}

		try {
			var assign = window.location.assign.bind(window.location);
			window.location.assign = function (url) {
				if (blockCartNavigation(url)) return;
				return assign(url);
			};
			var replace = window.location.replace.bind(window.location);
			window.location.replace = function (url) {
				if (blockCartNavigation(url)) return;
				return replace(url);
			};
		} catch (e) {}
	}

	function wrapWhereToGo() {
		if (typeof window.where_to_go !== "function" || window.where_to_go.__mhWrapped) return;
		var original = window.where_to_go;
		window.where_to_go = function () {
			if (stayInDrawerInsteadOfCartPage()) return;
			return original.apply(this, arguments);
		};
		window.where_to_go.__mhWrapped = true;
	}

	function initTrustpilot(root) {
		if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== "function") return;
		qsa(root || document, ".trustpilot-widget").forEach(function (el) {
			try {
				window.Trustpilot.loadFromElement(el, true);
			} catch (e) {}
		});
	}

	function notifyCartUpdated(cart) {
		document.dispatchEvent(new CustomEvent("mh:cart:updated", { detail: { cart: cart || null } }));
	}

	// Discount codes from Bundles Bear land on the cart via the /discount cookie. Liquid sees
	// them; /cart.js does not. The drawer total is section-rendered, so it is the figure the
	// header must show. cart.js is only a fallback for an empty cart, where that node is gone.
	function syncHeaderCartPrice(cart) {
		var costNodes = qsa(document, "#CartCost, #cart-price");
		if (!costNodes.length) return;
		var fromDrawer = document.querySelector("[data-mh-cd-header-total]");
		if (fromDrawer && fromDrawer.textContent.trim()) {
			var html = fromDrawer.innerHTML.trim();
			costNodes.forEach(function (el) {
				el.innerHTML = html;
			});
			return;
		}
		if (!cart) return;
		costNodes.forEach(function (el) {
			if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
				el.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
			}
		});
	}

	function updateHeaderCart() {
		syncHeaderCartPrice();
		return fetch("/cart.js")
			.then(function (res) {
				return res.json();
			})
			.then(function (cart) {
				rememberCart(cart);
				if (cartIsOnlyAddons(cart)) {
					clearAddonOnlyCart();
					return cart;
				}
				notifyCartUpdated(cart);
				syncDefaultAddons(cart);
				qsa(document, "#CartCount span, .cart-count, .item-count").forEach(function (el) {
					el.textContent = String(cart.item_count);
				});
				var countWrap = document.getElementById("CartCount");
				if (countWrap) {
					countWrap.classList.toggle("hidden-count", cart.item_count === 0);
				}
				syncHeaderCartPrice(cart);
				refreshShippingEstimate(cart);
				return cart;
			})
			.catch(function () {});
	}

	if (!customElements.get("mh-cart-drawer")) {
		customElements.define("mh-cart-drawer", MHCartDrawer);
	}

	// Registration must happen first: a throw in any of these bootstraps used to leave the
	// custom element undefined, so every cart trigger fell back to the cart page.
	bindBundleBearHooks();
	bindCheckoutNavigation();
	bindHistoryRestore();
	bindUpsellWheelPassthrough();
	initCartPageHandoff();
	document.addEventListener("DOMContentLoaded", wrapWhereToGo);
	setTimeout(wrapWhereToGo, 0);
	setTimeout(wrapWhereToGo, 800);
	setTimeout(wrapWhereToGo, 2000);
})();
